import styles from "./Styles/Modal.module.css"
import {MdClose} from "react-icons/md"

import React from 'react'

export default function Modal(props) {
  return (
    <React.Fragment>
    <div onClick={props.closeModalHandler} className={styles.overlay}></div>
    <div className={styles.modal} style={{width:props.width || '50%'}}>
        {props.closeIcon && <div onClick={props.closeModalHandler} className={styles.closeIcon}><MdClose size={24} color="#fff" /></div>}
        {props.children}
    </div>
    </React.Fragment>
  )
}
